import { GET_ALL_PIMS } from '../ActionTypes';

const initActions = (services) => {
    const axiosCall = services.axios.Axios();

    const getAllPims = () => async () => axiosCall.get('pims');

    const fetchAllPims = () => {
        return async (dispatch) => {
            let response = await axiosCall.get('pims');
            const allPims = response.data;
            dispatch(setAllPims(allPims));
        };
    };

    const setAllPims = (allPims) => {
        return {
            type: GET_ALL_PIMS,
            payload: allPims,
        };
    };

    const fetchPims = (pimsId) => {
        return async () => {
            try {
                var response = await axiosCall.get('pims/' + pimsId);
                return response.data;
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const togglePimsSupportsConnectivity = (pimsId) => {
        return async () => {
            try {
                await axiosCall.patch('pims/' + pimsId + '/connectivity');
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const saveNewPims = (payload = {}) => {
        return async () => {
            try {
                var response = await axiosCall.post('pims/new', payload);
                return response.data;
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const createPimsConfig = (payload = {}) => {
        return async () => {
            try {
                await axiosCall.post('pims/config', payload);
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const updatePimsConfig = (payload = {}) => {
        return async () => {
            try {
                await axiosCall.patch('pims/config', payload);
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const updatePimsAppRelation = (payload = {}) => {
        return async () => {
            try {
                await axiosCall.patch('pims/pimsAppRelation', payload);
            } catch (error) {
                console.error(error.message);
            }
        }
    }

    return {
        createPimsConfig,
        getAllPims,
        fetchAllPims,
        fetchPims,
        saveNewPims,
        togglePimsSupportsConnectivity,
        updatePimsConfig,
        updatePimsAppRelation,
    };
};

export default initActions;
